import type { InputGroupDesignTokens } from '@primeuix/themes/types/inputgroup'

export default {
  addon: {
    padding: '0.625rem 0.5rem',
    minWidth: '2.75rem',
    borderRadius: '{form.field.border.radius}',
  },
  colorScheme: {
    dark: {
      addon: {
        color: '{text.muted.color}',
        background: '{surface.800}',
        borderColor: '{form.field.border.color}',
      },
    },
    light: {
      addon: {
        color: '{text.muted.color}',
        background: '{surface.50}',
        borderColor: '{form.field.border.color}',
      },
    },
  },
} satisfies InputGroupDesignTokens
